import React from 'react';
import {
  Checkbox, Hash, Date, Title,
} from '@picsio/icons';

const DURATION_CUSTOM_FIELD_TITLE = 'Duration';

export function isDurationCustomField(field) {
  return field?.title === DURATION_CUSTOM_FIELD_TITLE;
}

export function getCustomFieldSortType(field) {
  if (isDurationCustomField(field)) return 'duration';
  return `meta.${field.title}`;
}

export function isCustomFieldSortActive(sortType, field) {
  if (!field?.title) return false;
  return sortType === getCustomFieldSortType(field)
    || sortType === `meta.${field.title}`;
}

export function getCustomFieldSortPresentation(field, sortConfig) {
  if (isDurationCustomField(field)) {
    return {
      ascText: sortConfig.duration.asc,
      descText: sortConfig.duration.desc,
      icon: sortConfig.duration.icon,
    };
  }

  if (field?.type === 'enum') {
    return {
      ascText: 'A-z',
      descText: 'Z-a',
      icon: sortConfig.meta.icon,
    };
  }

  if (field?.type === 'boolean') {
    return {
      ascText: 'Unset first',
      descText: 'Set first',
      icon: () => <Checkbox />,
    };
  }

  if (field?.type === 'int') {
    return {
      ascText: 'Min first',
      descText: 'Max first',
      icon: () => <Hash />,
    };
  }

  if (field?.type === 'date') {
    return {
      ascText: 'Old first',
      descText: 'New first',
      icon: () => <Date />,
    };
  }

  return {
    ascText: 'A-z',
    descText: 'Z-a',
    icon: () => <Title />,
  };
}
